import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFirefoxComponent } from './simple-icons-firefox.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFirefoxComponent ],
    exports:      [ SimpleIconsFirefoxComponent ],
    bootstrap:    []
})
export class SimpleIconsFirefoxModule {}
